import { useEffect, useState } from 'react';
import { Switch } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { CustomTableMeta } from '@/components/Tables/TableCard/TableCard.types';
import { PromotionData } from '@/types/promotions.types';

export const SwitchCell = ({ row, table, column }: CellContext<PromotionData, unknown>) => {
  const { original } = row;
  const { isLock, isAllLock, ...rest } = original;
  const { updateData } = table.options.meta as CustomTableMeta<PromotionData>;
  const [checked, setChecked] = useState(isLock);

  const handleClick = () => {
    const saveIsLock = !checked;
    setChecked((prevState) => !prevState);
    updateData(row.index, column.id, `${saveIsLock}`);
  };

  useEffect(() => {
    if (isAllLock !== undefined) {
      setChecked(isLock);
      return;
    }
    setChecked(checked);
  }, [checked, isAllLock, isLock]);

  return (
    <Switch data-testid="switch-once" color="error" title="switch" checked={checked} onClick={handleClick} {...rest} />
  );
};
